import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ASYNC_MENU_LOAD_DATA } from 'store';
import { Link } from 'react-router-dom';
import { Accordion } from 'react-bootstrap';
import style from './style.module.scss';
import { useTranslation } from 'react-i18next';
import Can from 'components/Can';
import { ProSidebar, SidebarHeader, SidebarContent, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import store from 'store/index';
import collect from 'collect.js';
import './style.css';

const MenuT = ({ className, loadMenu, menu, setEnlarged }) => {
  useEffect(() => {
    loadMenu();
  }, [loadMenu]);
  const minWidth = 768;
  const isMobile = window.innerWidth <= minWidth;

  const { t } = useTranslation('menu');

  // const createLink = ({ url, icon, title }) => (
  //   <Link to={url}>
  //     {icon ? <i className={icon}></i> : null}
  //     <span>{t(title)}</span>
  //   </Link>
  // );

  const createLink = ({ url, icon, title },k) => (
    <MenuItem key={k} icon= {icon ? <i className={icon}></i> : null} active={true}>
      <Link to={url} 
      onClick={()=>isMobile ? setEnlarged(true) : setEnlarged(!!className)}
      >
        {t(title)}
      </Link>
    </MenuItem>
  );
  

  const createToggleCollapseWithChildren = ({ icon, title, children },k) => (
    <SubMenu key={k} title={t(title)} icon={icon ? <i className={icon}></i> : null}>
      {listMenu(children)}
    </SubMenu>
  );

   // const createToggleCollapseWithChildren = ({ icon, title, children }) => (
  //   <>
  //     <Accordion.Toggle as={Link} to="#" eventKey={title}>
  //       {icon ? <i className={icon}></i> : null}
  //       <span>{t(title)}</span>
  //     </Accordion.Toggle>
  //     <Accordion.Collapse eventKey={title}>
  //       {createMenu(children, 'submenu')}
  //     </Accordion.Collapse>
  //   </>
  // );

  const createMenu = (menu, className = '') => (
    <Accordion>
      <ul className={`list-unstyled ${className}`}>
        {menu.map((mn, k) => (
          mn.permission ? (
          <Can do={mn.permission} on="App" key={k}>
          <li key={k}>
            {mn.route_id
              ? createLink({
                  url: mn.route.url,
                  icon: mn.icon,
                  title: mn.title
                })
              : createToggleCollapseWithChildren({
                  icon: mn.icon,
                  title: mn.title,
                  children: mn.children
                })}
          </li></Can>
          ): (
            <li key={k}>
            {mn.route_id
              ? createLink({
                  url: mn.route.url,
                  icon: mn.icon,
                  title: mn.title
                })
              : createToggleCollapseWithChildren({
                  icon: mn.icon,
                  title: mn.title,
                  children: mn.children
                })}
          </li>
          )
        ))}
      </ul>
    </Accordion>
  );

  const Header = (collapsed) => {
    return (
      <SidebarHeader>
        <div className="logo-box" style={{
          textAlign: 'center',
          padding: '17px'
        }}>
          <a href="/" className="logo text-center">
            <span className={collapsed?"logo-sm":"logo-lg"}>
              <img src={collapsed ? "/logo-sm.png" : "/logo-light.png"} alt="SIM" height="35" />
            </span>
          </a>
        </div>
      </SidebarHeader>
    );
  }

  const Content = (menu) => {
    return <SidebarContent className="mt-5">
      <Menu iconShape="square">
      {listMenu(menu)}
      </Menu>
    </SidebarContent>
  }

  const getPermission = (permission) => {
    return store.getState().user.profiles ? collect(store.getState().user.profiles[0].permissions).where('name',permission).count() > 0 : true;
  }

  const listMenu = (menu) => {
    return menu.filter(a=>{
      return a.permission ? getPermission(a.permission) : true;
    }).map((mn, k) => (
      mn.route_id
      ? createLink({
        url: mn.route.url,
        icon: mn.icon,
        title: mn.title
      },k)
      : createToggleCollapseWithChildren({
        icon: mn.icon,
        title: mn.title,
        children: mn.children
      },k)
    ));
  };

  return (<>
    <ProSidebar collapsed={!!className}>
      {Header(!!className)}
      {Content(menu)}
    </ProSidebar>
    {
      isMobile && !className?
      <div className="background-menu-mobile" onClick={() => setEnlarged(true)}><i class="fas fa-times"></i></div>
      :''
    }
  </>);
};

const mapStateToProps = state => ({
  menu: state.menu
});

const mapDispatchToProps = dispatch => ({
  loadMenu: () => dispatch({ type: ASYNC_MENU_LOAD_DATA })
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuT);
